import { WarehousingMasterData } from '../warehousing/warehousing.model';

export function warehousePickupIssue(item: string, warehouseId: number | null | undefined,
    pickupId: number | null | undefined, warehouses: WarehousingMasterData[]): string {
    if (!warehouseId) return `${item} requires an active source warehouse.`;
    if (!warehouses.length) return '';
    const warehouse = warehouses.find(row => row.id === warehouseId && row.isActive !== false && !row.deletedAt);
    if (!warehouse) return `${item} requires an active source warehouse.`;
    if (!pickupId || !warehouse.locationId || warehouse.locationId !== pickupId) {
        return `${item} uses source warehouse ${warehouse.name}, which does not match the pickup location. Change the pickup or source warehouse, or select inbound if receiving stock.`;
    }
    return '';
}
